import {
  PersonalXFromProjectData,
  TableCellAttribute,
  TableCellStyles,
  TableDataAdaptee,
  TableHeadData,
  TableRowData,
} from 'src/app/interfaces/tables.interfaces';
import { PendingUserInvolvementInProject } from 'src/app/swagger-api';

import {
  manageProjectTableHead,
  personalUserProjectXRowData,
  userRequestsTableCellAttributes,
} from '../table-users-list.data';
import { tableComponentStyles } from './table.styles';

export class PersonalUserRequestsFromProjectTableDataAdaptee implements TableDataAdaptee {
  public constructor(private dictionary: PersonalXFromProjectData) {}

  public getTableHeadData(): TableHeadData[] {
    return manageProjectTableHead;
  }

  public getCellAttributes(): TableCellAttribute[] {
    return userRequestsTableCellAttributes;
  }

  public getCellStyles(): TableCellStyles {
    return tableComponentStyles.tableWithDateAndManage;
  }

  public createTableBody(): TableRowData[] {
    return this.dictionary.personalEntities.map((request: PendingUserInvolvementInProject, id: number) =>
      personalUserProjectXRowData(id, request, this.dictionary.actorId, false),
    );
  }
}
